<div class="container-fluid">
  <div class="row">
    <div class="container-fluid">

      <div class="langs">
        <div class="flag" (click)="changeFlag('esp')">
          <img
               src="https://upload.wikimedia.org/wikipedia/commons/c/c3/Bandera_de_Espa%C3%B1a_%28nuevo_dise%C3%B1o%29.svg"
               alt="" />
        </div>
        <div class="flag" (click)="changeFlag('por')">
          <img
               src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_Portugal.svg/1200px-Flag_of_Portugal.svg.png"
               alt="" />
        </div>
        <div class="flag" (click)="changeFlag('eng')">
          <img
               src="../../assets/pngwing.com.png"
               alt="" />
        </div>
        <div class="flag" (click)="changeFlag('ita')">
          <img
               src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Flag_of_Italy.svg/960px-Flag_of_Italy.svg.png"
               alt="" />
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="start == true">

  <mat-card class="card-primary" *ngIf="!flag" style="background-color: white">
    <mat-card-content *ngIf="lang == 'esp'">
      <svg version="1.1" id="gofit_logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           x="0px" y="0px" viewBox="0 0 199.9 44.5" xml:space="preserve" class="logo"
           style="enable-background: new 0 0 199.9 44.5;">
        <style type="text/css">
          .fill-color {
            fill: var(--color-primary)
          }

          .fill-neutral {
            fill: var(--color-font)
          }
        </style>
        <g id="gofit" transform="translate(-23531.344 -20350)">
          <rect id="rect" x="23647.4" y="20385.8" width="20.2" height="4.4" class="fill-color"></rect>
          <path id="t"
                d="M23659,20357.4v5.1h5v3.8h-5v7.8c-0.2,1.2,0.7,2.3,1.9,2.5c0.1,0,0.3,0,0.4,0c0.7,0,1.5-0.2,2.1-0.5 l1.2,3.8c-1.2,0.5-2.4,0.7-3.7,0.8c-3.9,0.1-6.4-2.1-6.4-6.6v-7.8h-3.3v-3.8h3.3v-4.6L23659,20357.4z"
                class="fill-neutral"></path>
          <rect id="i" x="23640.6" y="20362.4" width="4.4" height="18" class="fill-neutral"></rect>
          <path id="i_dot" d="M23645.5,20357.4c0,3.5-5.2,3.5-5.2,0S23645.5,20353.9,23645.5,20357.4" class="fill-color">
          </path>
          <path id="f"
                d="M23624.2,20380.4v-13.8h-3.3v-3.9h3.3v-1.2c0-4.8,3.2-7,6.8-7c1.7,0,3.3,0.5,4.7,1.5l-1.6,3.3 c-0.8-0.6-1.7-0.9-2.7-0.9c-1.5,0-2.7,1-2.7,3.2v1.2h5.3v3.9h-5.3v13.8L23624.2,20380.4z"
                class="fill-neutral"></path>
          <path id="o"
                d="M23573.7,20370.4c0-11.9,8.9-20.4,21.4-20.4c12.5,0,21.3,8.5,21.3,20.4s-8.9,20.4-21.3,20.4 C23582.6,20390.8,23573.7,20382.3,23573.7,20370.4 M23605.3,20370.4c0-6.1-4.3-10.5-10.2-10.5c-5.5-0.1-10.1,4.3-10.3,9.8 c0,0.2,0,0.4,0,0.6c-0.2,5.5,4.1,10.2,9.6,10.4c0.2,0,0.4,0,0.6,0C23601,20380.9,23605.3,20376.5,23605.3,20370.4"
                class="fill-color"></path>
          <path id="g"
                d="M23572.5,20369.1c0,12.7-8.3,21.8-20.5,21.8c-11.9,0-20.7-8.6-20.7-20.4c0-11.8,8.6-20.4,20.6-20.4 c10.2,0,18.5,6.4,20.2,15.4h-11.2c-1.6-3.4-5.1-5.5-8.9-5.4c-5.8,0-9.7,4.2-9.7,10.4c0,6.1,3.9,10.4,9.7,10.4c4.1,0,7.6-2,8.8-5 h-9.6v-6.7L23572.5,20369.1z"
                class="fill-color"></path>
        </g><text id="inspira" x="148" y="40" class="fill-color">inspira</text>
      </svg>
      <h2 style="text-align: center">
        Esta encuesta ya no se encuentra disponible
      </h2>
    </mat-card-content>
    <mat-card-content *ngIf="lang == 'eng'">
      <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
           alt="logo Gofit" class="logo" />
      <h2 style="text-align: center">This survey is no longer available</h2>
    </mat-card-content>
    <mat-card-content *ngIf="lang == 'por'">
      <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
           alt="logo Gofit" class="logo" />
      <h2 style="text-align: center">Esta pesquisa não está mais disponível</h2>
    </mat-card-content>
    <mat-card-content *ngIf="lang == 'ita'">
      <img
           src="../assets/logo.png"
           alt="logo Gofit"
           class="logo" />
      <h2 style="text-align: center">Questo articolo non è disponibile per te</h2>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="flag" class="card-primary  mat-elevation-z" style="background-color: white">
    <mat-card-content *ngIf="questions ">
      <img src="https://go-fit.es/wp-content/uploads/2022/04/Logo-GO-fit-LIFE-SCIENCE-TECH_RGB_02-1.svg"
           alt="logo Gofit" class="logo" />
      <div class="question" *ngFor="let q of questions; index as i">
        <div class="ask {{ q.type }}" *ngIf="q.type == 'escala' && step >= 0">
          {{ q.name }}
        </div>
        <div class="escalas" *ngIf="q.type == 'escala' && step >= 0" [ngClass]="{
          'xsel-0': asks[0] === 0,
          'xsel-1': asks[1] === 1,
          'xsel-2': asks[2] === 2,
          'xsel-3': asks[3] === 3,
          'xsel-4': asks[4] === 4,
          'xsel-5': asks[5] === 5,
          'xsel-6': asks[6] === 6,
          'xsel-7': asks[7] === 7,
          'xsel-8': asks[8] === 8,
          'xsel-9': asks[9] === 9,
          'xsel-10': asks[10] === 10
        }">
          <div class="item" [ngClass]="{ active: asks[10] == 10 }" (click)="update(10, { value: 10 })">
            <p>10</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[9] == 9 }" (click)="update(9, { value: 9 })">
            <p>9</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[8] == 8 }" (click)="update(8, { value: 8 })">
            <p>8</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[7] == 7 }" (click)="update(7, { value: 7 })">
            <p>7</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[6] == 6 }" (click)="update(6, { value: 6 })">
            <p>6</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[5] == 5 }" (click)="update(5, { value: 5 })">
            <p>5</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[4] == 4 }" (click)="update(4, { value: 4 })">
            <p>4</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[3] == 3 }" (click)="update(3, { value: 3 })">
            <p>3</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[2] == 2 }" (click)="update(2, { value: 2 })">
            <p>2</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[1] == 1 }" (click)="update(1, { value: 1 })">
            <p>1</p>
          </div>
          <div class="item" [ngClass]="{ active: asks[0] == 0 }" (click)="update(0, { value: 0 })">
            <p>0</p>
          </div>
        </div>
        <div class="informativo" *ngIf="q.type == 'escala' && step >= 0">
          <p *ngIf="escala && lang == 'esp'">Usted ha dado una puntuación <span>{{escala}}</span>
            <button *ngIf="step < 0.5" style="top: -6px;
          left: 6px;     background-color: #e55750;" mat-flat-button color="primary"
                    (click)="toContinue()">Continuar</button>
          </p>
          <p *ngIf="escala && lang == 'por'">Você deu uma pontuação <span>{{escala}}</span>
            <button *ngIf="step < 0.5" style="top: -6px;
           left: 6px;     background-color: #e55750;" mat-flat-button color="primary"
                    (click)="toContinue()">Continuar</button>
          </p>
          <p *ngIf="escala && lang == 'eng'">You have given a rating <span>{{escala}}</span>
            <button *ngIf="step < 0.5" style="top: -6px;
           left: 6px;     background-color: #e55750;" mat-flat-button color="primary"
                    (click)="toContinue()">Continue</button>
          </p>
          <p *ngIf="escala && lang == 'ita'">Hai dato un punteggio <span>{{escala}}</span>
            <button *ngIf="step < 0.5" style="top: -6px;
           left: 6px;     background-color: #e55750;" mat-flat-button color="primary"
                    (click)="toContinue()">Continuare</button>
          </p>
        </div>

        <div class="open-answer" *ngIf="q.type == 'escala' && step >= 0.5">
          <div *ngIf="low">
            <div class="ask">
              <p *ngIf="lang == 'esp'">¿Por qué no nos recomendarías?</p>
              <p *ngIf="lang == 'por'">Por que motivo não nos recomendaria?</p>
              <p *ngIf="lang == 'eng'">Why wouldn't you recommend us?</p>
              <p *ngIf="lang == 'ita'">Per quale motivo non ci raccomanderesti?</p>

            </div>
            <textarea name="" [(ngModel)]="commit" (ngModelChange)="valuechange($event)"></textarea>
          </div>
          <div *ngIf="mid">
            <div class="ask">
              <p *ngIf="lang == 'esp'">
                ¿Qué aspectos deberíamos mejorar para que nos recomendaras más?
              </p>
              <p *ngIf="lang == 'eng'">
                What aspects should we improve so that you would recommend us
                more?
              </p>
              <p *ngIf="lang == 'por'">
                Quais são os aspectos que deveríamos melhorar para recomendar-nos
                mais?
              </p>
              <p *ngIf="lang == 'ita'">
                Quali aspetti dovremmo migliorare affinché tu potessi raccomandarci maggiormente?
              </p>
            </div>
            <textarea name="" [(ngModel)]="commit" (ngModelChange)="valuechange($event)"></textarea>
          </div>
          <div *ngIf="higth">
            <div class="ask">
              <p *ngIf="lang == 'esp'">
                ¿Qué aspectos destacas cuando nos recomiendas?
              </p>
              <p *ngIf="lang == 'eng'">
                What aspects do you highlight when you recommend us?
              </p>
              <p *ngIf="lang == 'por'">
                Quais são os aspectos que você destaca quando recomenda GO fit?
              </p>
              <p *ngIf="lang == 'ita'">
                Quali sono gli aspetti che spiccano quando ci raccomandi?
              </p>
            </div>
            <textarea [(ngModel)]="commit" (ngModelChange)="valuechange($event)"></textarea>
          </div>
          <a (click)="valuechange('')" *ngIf="lang == 'esp'" class="light">No quiero responder</a>
          <a (click)="valuechange('')" *ngIf="lang == 'eng'" class="light">I do not want to answer</a>
          <a (click)="valuechange('')" *ngIf="lang == 'por'" class="light">Não quero responder</a>
                  <a (click)="valuechange('')" *ngIf="lang == 'ita'" class="light">Preferisco non rispondere</a>

        </div>

        <div class="zones" *ngIf="q.type == 'checkbox' && step >= 1">
          <div class="ask {{ q.type }}">
            {{ q.name }}
          </div>
          <div *ngFor="let z of zone">
            <mat-checkbox *ngIf="lang == z.idioma" [(ngModel)]="z.isChecked" (change)="someComplete(z.id)">{{
              z.text
              }}
            </mat-checkbox>
          </div>
        </div>
        <div class="zones-2" *ngIf="q.type == 'checkbox-child' && step >= 1 && showZoneFit()">
          <div class="ask {{ q.type }}">
            {{ q.name }}
          </div>
          <div *ngFor="let z of zoneFit">
            <mat-checkbox *ngIf="lang == z.idioma" [(ngModel)]="z.isChecked" (change)="someComplete(z.id)">{{
              z.text
              }}
            </mat-checkbox>
          </div>
        </div>
        <div *ngIf="q.type == 'radio' && step >= 2">
          <div class="ask {{ q.type }}">
            {{ q.name }}
          </div>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio($event)" class="radios"
                           *ngIf="lang == 'esp'" [(ngModel)]="selectRecomendation">
            <mat-radio-button class="example-radio-button" *ngFor="let r of optionRecomendation" [value]="r">
              {{ r }}
            </mat-radio-button>
          </mat-radio-group>

          <mat-radio-group aria-label="Select an option" (change)="updateRadio($event)"
                           [(ngModel)]="selectRecomendation" class="radios" *ngIf="lang == 'eng'">
            <mat-radio-button class="example-radio-button" *ngFor="let r of optionRecomendation1" [value]="r">
              {{ r }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio($event)"
                           [(ngModel)]="selectRecomendation" class="radios" *ngIf="lang == 'por'">
            <mat-radio-button class="example-radio-button" *ngFor="let r of optionRecomendation2" [value]="r">
              {{ r }}
            </mat-radio-button>
          </mat-radio-group>
            <mat-radio-group aria-label="Select an option" (change)="updateRadio($event)"
                           [(ngModel)]="selectRecomendation" class="radios" *ngIf="lang == 'ita'">
            <mat-radio-button class="example-radio-button" *ngFor="let r of optionRecomendation3" [value]="r">
              {{ r }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="q.type == 'radio2' && step >= 3">
          <div class="ask {{ q.type }}">
            {{ q.name }}
          </div>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio2($event)" [(ngModel)]="selectObjetive"
                           class="radios" *ngIf="lang == 'esp'">
            <mat-radio-button class="example-radio-button" *ngFor="let o of objective" [value]="o">
              {{ o }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio2($event)" [(ngModel)]="selectObjetive"
                           class="radios" *ngIf="lang == 'eng'">
            <mat-radio-button class="example-radio-button" *ngFor="let o of objective2" [value]="o">
              {{ o }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio2($event)" [(ngModel)]="selectObjetive"
                           class="radios" *ngIf="lang == 'por'">
            <mat-radio-button class="example-radio-button" *ngFor="let o of objective1" [value]="o">
              {{ o }}
            </mat-radio-button>
          </mat-radio-group>
          <mat-radio-group aria-label="Select an option" (change)="updateRadio2($event)" [(ngModel)]="selectObjetive"
                           class="radios" *ngIf="lang == 'ita'">
            <mat-radio-button class="example-radio-button" *ngFor="let o of objective3" [value]="o">
              {{ o }}
            </mat-radio-button>
          </mat-radio-group>
        </div>

      </div>
      <div *ngIf="step >= 3">
        <button (click)="save()" class="float-right" *ngIf="step >= 3" mat-flat-button color="accent">
          Guardar
        </button>
      </div>
      <!-- <button
      (click)="save()"
      class="float-right"
      *ngIf="step >= 3"
      mat-flat-button
      color="accent"
    >
      Guardar
    </button> -->
    </mat-card-content>

  </mat-card>

</div>
<div *ngIf="start == false">
  <mat-spinner color="secondary"></mat-spinner>
</div>